export default __webpack_public_path__ + "static/media/download.831a989f.svg";